const styles = theme => ({
  value: theme.mixins.gutters({
    margin: 0,
    fontWeight: 200
  }),
  wow:{
    color:'red',
  }
})

export default styles
